import React from 'react'
import Row from "@amzn/meridian/row";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {getLocaleDateTime} from "../util/Util";
import {FormattedMessage} from "react-intl";

const LineHaulInfo = (props) => {
    return (
        <div>
            <Row widths={["grid-12"]}  alignmentVertical="top" spacingInset="large large none large">
                <BreadcrumbGroup>
                    <Breadcrumb href="#receive">
                        <FormattedMessage id="linehaul_detail.receive" defaultMessage="Receive"/>
                    </Breadcrumb>
                    <Breadcrumb>
                        <FormattedMessage id="linehaul_detail.linehaul_details" defaultMessage="Linehaul Details"/>
                    </Breadcrumb>
                </BreadcrumbGroup>
            </Row>
            <Row widths={["grid-12"]}  alignmentVertical="top" spacingInset="none large medium large">
                <Heading level={1}>
                    <FormattedMessage id="linehaul_detail.linehaul" defaultMessage="Linehaul"/>
                    {props.lineHaul.lineHaulId}
                </Heading>
            </Row>
            <Row widths={["grid-1", "grid-11"]} alignmentVertical="top" spacingInset="none large none">
                <Text type="h100">
                    <FormattedMessage id="linehaul_detail.from" defaultMessage="From"/>
                </Text>
                <Text type="b200">{props.lineHaul.origin}</Text>
            </Row>
            <Row widths={["grid-1", "grid-11"]} alignmentVertical="top" spacingInset="medium large none large">
                <Text type="h100">
                    <FormattedMessage id="linehaul_detail.departed" defaultMessage="Departed"/>
                </Text>
                <Text type="b200">{getLocaleDateTime(props.lineHaul.departTime)}</Text>
            </Row>
            <Row widths={["grid-1", "grid-3"]} alignmentVertical="top" spacingInset="medium large none large">
                <Text type="h100">
                    <FormattedMessage id="linehaul_detail.arrived" defaultMessage="Arrived"/>
                </Text>
                <Text type="b200">{getLocaleDateTime(props.lineHaul.arrivalTime)}</Text>
            </Row>
        </div>
    );
}
export default LineHaulInfo


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHaulInfo.js